import React from 'react';
import _ from 'lodash';

import { useFieldBulletinBoardEdit } from '../../services/fieldBulletinBoard/FieldBulletinBoardEditContext';

import { FieldBulletinBoardContents } from './FieldBulletinBoardContents';

/**
 * 現場掲示板編集 お知らせ内容
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardContentsEdit() {
  const {
    getData,
    getUploadFiles,
    getFormErrorMessage,
    handleChangeData,
    validateFormItem,
    handleFileUpload,
    handleFileDelete,
    fileRef,
  } = useFieldBulletinBoardEdit();

  const formErrorMessage = getFormErrorMessage();

  // ファイルアップロードエラーメッセージの重複を除外
  const fileErrorMessage =
    _.has(formErrorMessage, 'files') &&
    _.uniq(
      Object.values(
        _.flatten(
          _.map(formErrorMessage.files, file => {
            return file;
          })
        )
      )
    );

  const uploadFiles = getUploadFiles();
  const data = getData();

  return (
    <React.Fragment>
      <FieldBulletinBoardContents
        handleChangeData={handleChangeData}
        validateFormItem={validateFormItem}
        handleFileUpload={handleFileUpload}
        handleFileDelete={handleFileDelete}
        fileRef={fileRef}
        data={data}
        uploadFiles={uploadFiles}
        formErrorMessage={formErrorMessage}
        fileErrorMessage={fileErrorMessage}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardContentsEdit.jsx